import { _StoreWithGetters, PiniaCustomProperties, _GettersTree } from 'pinia';
import { UnwrapRef } from 'vue';
import { UserStateInterface } from './state';

import { realmUserLoggedIn } from 'src/services/functions';

export type UserGetters = {
  isLoggedIn(state: UnwrapRef<UserStateInterface>): boolean;
  isFirstTime(state: UnwrapRef<UserStateInterface>): boolean;
};

const getters: UserGetters &
  ThisType<
    UnwrapRef<UserStateInterface> &
      _StoreWithGetters<UserGetters> &
      PiniaCustomProperties
  > &
  _GettersTree<UserStateInterface> = {
  isLoggedIn(state) {
    if (state.type && state.type === 'local-userpass') {
      return realmUserLoggedIn();
    }
    return false;
  },
  isFirstTime(state) {
    return state.firstTime;
  }
};

export default getters;
